export const initialState = {
    loading: false,
    relation:{},
    relations: [],
    response: { message: null, error: null },
    tabSelected: 0,
}